var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "launch", tag: "section" }
    },
    [
      _vm.busy
        ? _c("v-progress-circular", { attrs: { indeterminate: "", large: "" } })
        : _vm._e(),
      !_vm.busy && !_vm.error
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
              _c("v-card-text", [
                _c(
                  "div",
                  [
                    _vm._v(" " + _vm._s(_vm.$t("launch.step1.text")) + " "),
                    _c(
                      "v-stepper",
                      {
                        staticClass: "no-gutter no-border",
                        attrs: { vertical: "" },
                        model: {
                          value: _vm.step,
                          callback: function($$v) {
                            _vm.step = $$v
                          },
                          expression: "step"
                        }
                      },
                      [
                        _c(
                          "v-stepper-step",
                          {
                            staticClass: "cursor",
                            attrs: { complete: _vm.step > 1, step: "1" },
                            on: {
                              click: function($event) {
                                return _vm.gotoStep(1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("launch.step1.title")) + " "
                            )
                          ]
                        ),
                        _c("v-stepper-content", { attrs: { step: "1" } }, [
                          _vm.busy
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        [
                                          _c("v-progress-circular", {
                                            attrs: { indeterminate: "" }
                                          }),
                                          _vm._v(" busy")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.busy
                            ? _c(
                                "div",
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("launch.step1.subtitle"))
                                    )
                                  ]),
                                  _c(
                                    "v-row",
                                    { style: { padding: "6px" } },
                                    _vm._l(_vm.availablePlatforms, function(
                                      platform
                                    ) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: platform,
                                          attrs: { cols: "12", sm: "4" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              class: platform,
                                              attrs: {
                                                disabled: !_vm.supported(
                                                  platform
                                                ),
                                                tile: "",
                                                block: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectPlatform(
                                                    platform
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { staticClass: "mr-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.iconForPlatform(
                                                          platform
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "platforms." + platform
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                  _c("br"),
                                  _vm.availablePlatforms.includes("web")
                                    ? _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("launch.stream-guidance")
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  !_vm.streamingSupportedOnBrowser()
                                    ? _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "launch.stream-not-supported"
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _c(
                          "v-stepper-step",
                          {
                            staticClass: "cursor",
                            attrs: { complete: _vm.step > 2, step: "2" },
                            on: {
                              click: function($event) {
                                return _vm.gotoStep(2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("launch.step2.title")) + " "
                            )
                          ]
                        ),
                        _c(
                          "v-stepper-content",
                          { attrs: { step: "2" } },
                          [
                            _vm.selectedPlatform
                              ? _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("launch.step2.text", [
                                          _vm.$t(
                                            "platforms." + _vm.selectedPlatform
                                          )
                                        ])
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: _vm.launchLink
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("launch.step2.here"))
                                      )
                                    ]
                                  ),
                                  _vm._v(". "),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(_vm.$t("launch.install-warning")) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "secondary" },
                                on: {
                                  click: function($event) {
                                    _vm.step = 3
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.continue")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-stepper-step",
                          {
                            staticClass: "cursor",
                            attrs: { complete: _vm.step > 3, step: "3" },
                            on: {
                              click: function($event) {
                                return _vm.gotoStep(3)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("launch.step3.title")) + " "
                            )
                          ]
                        ),
                        _c(
                          "v-stepper-content",
                          { attrs: { step: "3" } },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("launch.step3.text")))
                            ]),
                            _c("shortcode-generator", {
                              ref: "generator",
                              attrs: {
                                mini: "",
                                action: _vm.action,
                                "invite-code": _vm.inviteCode,
                                account: _vm.source,
                                user: _vm.user,
                                module: _vm.getModuleId(),
                                "no-button": "",
                                "auto-generate": ""
                              }
                            }),
                            _vm._v(" "),
                            _c("br"),
                            _c(
                              "p",
                              [
                                _c(
                                  "i18n",
                                  {
                                    attrs: {
                                      path: "launch.step3.text2",
                                      tag: "label",
                                      for: "launch.step3.here"
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            return _vm.refreshCode()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("launch.step3.here"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "p",
                              [
                                _c(
                                  "i18n",
                                  {
                                    attrs: {
                                      path: "launch.step3.text3",
                                      tag: "label",
                                      for: "launch.step3.help-center"
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.codesHelpLink,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("launch.step3.help-center")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.error
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.$t("global.error")))]),
              _c("v-card-text", { domProps: { innerHTML: _vm._s(_vm.error) } })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }